// Convert YouTube / Loom / Vimeo / direct video URLs to embed URLs.
// Returns { embedUrl, kind } or null if unrecognized.

export function toEmbedUrl(rawUrl) {
    if (!rawUrl || typeof rawUrl !== "string") return null;
    const url = rawUrl.trim();
    try {
        const u = new URL(url);
        const host = u.hostname.replace(/^www\./, "");

        // YouTube — youtube.com/watch?v=, youtu.be/, youtube.com/shorts/
        if (host === "youtube.com" || host === "m.youtube.com") {
            if (u.pathname === "/watch") {
                const id = u.searchParams.get("v");
                if (id) return { embedUrl: `https://www.youtube.com/embed/${id}`, kind: "youtube" };
            }
            const shortsMatch = u.pathname.match(/^\/shorts\/([a-zA-Z0-9_-]+)/);
            if (shortsMatch) return { embedUrl: `https://www.youtube.com/embed/${shortsMatch[1]}`, kind: "youtube" };
            const embedMatch = u.pathname.match(/^\/embed\/([a-zA-Z0-9_-]+)/);
            if (embedMatch) return { embedUrl: `https://www.youtube.com/embed/${embedMatch[1]}`, kind: "youtube" };
        }
        if (host === "youtu.be") {
            const id = u.pathname.replace("/", "");
            if (id) return { embedUrl: `https://www.youtube.com/embed/${id}`, kind: "youtube" };
        }

        // Loom — loom.com/share/<id> or loom.com/embed/<id>
        if (host === "loom.com") {
            const m = u.pathname.match(/^\/(?:share|embed)\/([a-zA-Z0-9]+)/);
            if (m) return { embedUrl: `https://www.loom.com/embed/${m[1]}`, kind: "loom" };
        }

        // Vimeo — vimeo.com/<id>
        if (host === "vimeo.com" || host === "player.vimeo.com") {
            const m = u.pathname.match(/^\/(?:video\/)?(\d+)/);
            if (m) return { embedUrl: `https://player.vimeo.com/video/${m[1]}`, kind: "vimeo" };
        }

        // Direct video file
        if (/\.(mp4|webm|mov)(\?|$)/i.test(u.pathname)) {
            return { embedUrl: url, kind: "file" };
        }
    } catch (_) {
        return null;
    }
    return null;
}
